import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { BAlert, BButton, BCard, BCardGroup, BFormSelect, BFormSelectOption, BListGroup, BListGroupItem, BModal, } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import Multiselect from "vue-multiselect";
import { useConfig } from "@/composables/config";
import { getAppRoot } from "@/onload";
import { useUserStore } from "@/stores/userStore";
import { assertArray } from "@/utils/assertions";
import Heading from "../Common/Heading.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserSharing',
    props: {
        item: null,
        modelClass: null
    },
    emits: ["share", "error", "cancel"],
    setup(__props, { expose, emit }) {
        const props = __props;
        const { currentUser } = storeToRefs(useUserStore());
        const { config, isConfigLoaded } = useConfig(false);
        const permissionsChangeRequired = computed(() => {
            if (props.item.extra) {
                return props.item.extra.can_change.length > 0 || props.item.extra.cannot_change.length > 0;
            }
            else {
                return false;
            }
        });
        const userIsAdmin = computed(() => currentUser.value && "is_admin" in currentUser.value && currentUser.value.is_admin);
        const exposeEmails = computed(() => config.value.expose_user_email || userIsAdmin.value);
        const sharingCandidates = ref([...(props.item.users_shared_with ?? [])]);
        const sharingCandidatesAsEmails = computed(() => sharingCandidates.value.map(({ email }) => email));
        function reset() {
            sharingCandidates.value = [...(props.item.users_shared_with ?? [])];
        }
        const userOptions = ref([]);
        const currentSearch = ref("");
        async function onSearchChanged(searchValue) {
            currentSearch.value = searchValue;
            if (!exposeEmails.value) {
                userOptions.value = [{ email: searchValue }];
            }
            else if (searchValue.length < 3) {
                userOptions.value = [];
            }
            else {
                try {
                    const response = await axios.get(`${getAppRoot()}api/users?f_email=${searchValue}`);
                    const data = response.data;
                    assertArray(data);
                    userOptions.value = data.filter((value) => value &&
                        typeof value === "object" &&
                        "email" in value &&
                        typeof value.email === "string" &&
                        !sharingCandidatesAsEmails.value.includes(value.email));
                }
                catch (e) {
                    emit("error", e);
                }
            }
        }
        function onBlur() {
            const isValueChosen = sharingCandidates.value.some(({ email }) => email === currentSearch.value);
            if (currentSearch.value && !exposeEmails.value && !isValueChosen) {
                sharingCandidates.value.push({ email: currentSearch.value });
            }
        }
        function onRemove(user) {
            const index = sharingCandidates.value.indexOf(user);
            if (index >= 0) {
                sharingCandidates.value.splice(index, 1);
            }
        }
        const charactersThresholdWarning = "Enter at least 3 characters to see suggestions";
        const elementsNotFoundWarning = "No elements found. Consider changing the search query";
        function onCancel() {
            sharingCandidates.value = [...(props.item.users_shared_with ?? [])];
            emit("cancel");
        }
        function onSubmit() {
            emit("share", sharingCandidatesAsEmails.value);
        }
        const noChanges = computed(() => {
            const candidates = [...sharingCandidatesAsEmails.value];
            const sharedWith = [...(props.item.users_shared_with ?? []).map(({ email }) => email)];
            const newCandidates = candidates.filter((email) => !sharedWith.includes(email));
            const removedShared = sharedWith.filter((email) => !candidates.includes(email));
            return !(newCandidates.length !== 0 || removedShared.length !== 0);
        });
        const canChangeCount = computed(() => props.item.extra?.can_change.length ?? 0);
        const cannotChangeCount = computed(() => props.item.extra?.cannot_change.length ?? 0);
        const selectedSharingOption = ref("make_public");
        function onUpdatePermissions() {
            emit("share", sharingCandidatesAsEmails.value, selectedSharingOption.value);
        }
        expose({
            reset,
        });
        return { __sfc: true, props, emit, currentUser, config, isConfigLoaded, permissionsChangeRequired, userIsAdmin, exposeEmails, sharingCandidates, sharingCandidatesAsEmails, reset, userOptions, currentSearch, onSearchChanged, onBlur, onRemove, charactersThresholdWarning, elementsNotFoundWarning, onCancel, onSubmit, noChanges, canChangeCount, cannotChangeCount, selectedSharingOption, onUpdatePermissions, BAlert, BButton, BCard, BCardGroup, BFormSelect, BFormSelectOption, BListGroup, BListGroupItem, BModal, Multiselect, Heading };
    }
});
